// Thin wrapper around import.meta.env so callers can read env vars without
// repeating the cast. Vite inlines these at build time.

type EnvLike = Record<string, string | boolean | undefined>;

const env = import.meta.env as unknown as EnvLike;

export const getEnv = (key: string): string => String(env[key] ?? "");

export const isProd = (): boolean => env.PROD === true;

export const isDev = (): boolean => env.DEV === true;
